export default "__VITE_ASSET__cab5a144__"